import { httpClient } from "infra/axios/axios-api";
import { Message } from "domain/entities/message";
import { Page, PageType } from "domain/entities/Page";

type CreatePayload = { data: { name: string; type: PageType } };
type RenamePayload = { data: { name: string } };
type UpdatePayload = { data: { name?: string; image?: string; description?: string } };

class PageRepository {
  async getAll(type: PageType): Promise<Message<Page[]>> {
    const res = await httpClient.get(`/page/type/${type}`);
    return res.data as Message<Page[]>;
  }

  async create(name: string, type: PageType): Promise<Message<Page>> {
    const payload: CreatePayload = { data: { name, type } };
    const res = await httpClient.post(`/page`, payload);
    return res.data as Message<Page>;
  }

  async rename(id: string, name: string): Promise<Message<boolean>> {
    const payload: RenamePayload = { data: { name } };
    const res = await httpClient.put(`/page/${id}`, payload);
    return res.data as Message<boolean>;
  }

  async update(id: string, data: { name?: string; image?: string; description?: string }): Promise<Message<boolean>> {
    const payload: UpdatePayload = { data };
    const res = await httpClient.put(`/page/${id}`, payload);
    return res.data as Message<boolean>;
  }

  async remove(id: string): Promise<Message<boolean>> {
    const res = await httpClient.delete(`/page/all-content/${id}`);
    return res.data as Message<boolean>;
  }
}

const pageRepository = new PageRepository();
export default pageRepository;
